module.exports = __webpack_public_path__ + "media/images/stoneypoint/hero-image-903110cab57e55e6fcba4ae3d7daf231.png";